import React from 'react';
import { ListItem, Text } from '@tesla/design-system-react';
import { string, arrayOf, shape } from 'prop-types';
import Styles from '../RegionSelector.module.css.js';

var CountryAndLanguage = function CountryAndLanguage(_ref) {
  var countryName = _ref.countryName,
    languages = _ref.languages,
    key = _ref.key,
    selected = _ref.selected,
    t = _ref.t,
    userLocale = _ref.userLocale;
  var defaultLanguage = languages[0];
  return /*#__PURE__*/React.createElement(ListItem, {
    key: key,
    className: Styles["tw-react--region-selector--modal--region--country".concat(selected ? '--selected' : '')]
  }, /*#__PURE__*/React.createElement(Text, {
    is: "p",
    weight: "medium"
  }, countryName.indexOf(userLocale.regionName) !== -1 ? userLocale.countryName : t.allCountries), /*#__PURE__*/React.createElement(Text, {
    is: "p",
    weight: "medium",
    caption: true
  }, defaultLanguage.languageName));
};
CountryAndLanguage.defaultProps = {
  countryName: '',
  languages: [],
  key: '',
  selected: '',
  userLocale: {}
};
CountryAndLanguage.propTypes = {
  countryName: string,
  languages: arrayOf(shape({
    languageName: string
  })),
  key: string,
  selected: string,
  userLocale: shape({
    countryName: string,
    regionName: string
  }),
  t: shape({
    signout: string,
    allCountries: string,
    supportLink: string
  }).isRequired
};

export { CountryAndLanguage as default };
